<template>
    <div>
        <span v-if="(column.custom_field_type === 'USER' || column.custom_field_type === 'DROPDOWN')">
            <select :value="getCustomFieldValue(project.record_detail_custom_field_data, column.custom_field_id, column.custom_field_type)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']"
                    @change="manageInlineUpdateValue($event, column, project)">
                    <option></option>
                    <option v-for="item in column.custom_field_options" :value="item.id">{{ item.name }}</option>
            </select>
        </span>
        <span v-if="column.custom_field_type === 'TEXT'">
            <input :value="getCustomFieldValue(project.record_detail_custom_field_data, column.custom_field_id)"
                   type="text"
                   class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                   :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']"
                   @change="manageInlineUpdateValue($event, column, project)">
        </span>
        <span v-if="column.custom_field_type === 'DATE'">
            <datetime type="date"
                      :value="getCustomFieldValue(project.record_detail_custom_field_data, column.custom_field_id, column.custom_field_type)"
                      value-zone="local"
                      class="w-full"
                      :format="masks.date_mask"
                      :week-start="7"
                      :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '', 'appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full']"
                      @input="manageInlineUpdateValue($event, column, project)">
            </datetime>
        </span>
    </div>
</template>

<script>
export default {
    name: 'inline-update-record-detail-custom-fields',
    props: ['column', 'project', 'masks', 'requiredFieldProjectId'],
    methods: {
        getCustomFieldValue(customFieldsData, fieldId, type = null) {
            for(let i = 0; i < customFieldsData.length; i++) {
                if (customFieldsData[i].id === fieldId) {
                    if(type && type === 'DATE') {
                        let finalValue = null;
                        if(customFieldsData[i].value && customFieldsData[i].value.trim() !== "") {
                            finalValue = customFieldsData[i].value;
                        }
                        return finalValue;
                    }
                    else {
                        return customFieldsData[i].value;
                    }
                }
            }
        },
        manageInlineUpdateValue(event, column, project) {
            let self = this;
            if(event) {
                let valueItem = '';
                let dateFormat = 'MM/DD/yyyy';
                if(column.custom_field_type !== 'DATE') {
                    valueItem = event.target.value;
                    self.$parent.payload = {
                        'inlineColumnType': column.custom_field_id,
                        'inlineColumnValue': valueItem,
                        'project': project,
                        'isCustomField': true,
                        'isRecordDetailCustomField': true
                    }
                    self.$parent.sendPostRequest();
                }
                else {
                    valueItem = event;
                    _.each(project.record_detail_custom_field_data, function(customField) {
                        if (customField.id == column.custom_field_id && valueItem && valueItem != "" && moment(customField.value).format(dateFormat) !== moment(valueItem).format(dateFormat)) {
                            self.$parent.payload = {
                                'inlineColumnType': column.custom_field_id,
                                'inlineColumnValue': moment(valueItem).format('YYYY-MM-DD'),
                                'project': project,
                                'isCustomField': true,
                                'isRecordDetailCustomField': true
                            }
                            self.$parent.sendPostRequest();
                        }
                    });
                }

            }
        }
    }
}
</script>
